import { Component } from 'react';
import PropTypes from 'prop-types';

import { pushRollbarError } from 'utils/rollbar';

export default class CatchError extends Component {
    static propTypes = {
        renderOnError: PropTypes.func.isRequired,
        children: PropTypes.node.isRequired,
        reset: PropTypes.bool
    }

    state = {
        error: null,
        info: null
    }

    componentDidCatch(error, info) {
        pushRollbarError(error, info);
        this.setState({ error, info });
    }

    reset = () => this.setState({ error: null, info: null });

    componentDidUpdate(props) {
        const isNotEmptyState = !!this.state.error;
        props.reset && isNotEmptyState && this.reset();
    }

    render() {
        const { renderOnError } = this.props;

        return this.state.error ? (
            renderOnError(this.reset)
        ) : this.props.children;
    }
}
